export default {
  saas: {
    advanced: {
      id: 82 // 高级版
    },
    flagship: {
      id: 132 // 旗舰版11
    },
    professionClothing: {
      id: 67, // 行业版-服装
      quantity: 12
    },
    professionBarber: {
      id: 77, // 行业版-丽人
      quantity: 12
    },
    profession3C: {
      id: 68, // 行业版-手机数码
      quantity: 12
    },
    food: { // 餐饮版本
      id: 76,
      quantity: 12
    },
    shopWindow: {
      id: 105 // 手机橱窗
    },
    wechatCard: {
      id: 106, // 微信会员卡
      quantity: 12
    },
    mobileMessage: {
      id: 45 // 短信包
    },
    mobilePay: {
      id: 118 // 移动支付
    },
    perpetualAdvanced: {
      id: 119 // 终身高级版预购
    },
    perpetualProfession: {
      id: 120 // 终身行业版预购
    },
    perpetualAdvancedNormal: {
      id: 127 // 终身高级版正式购
    },
    a8Pos: {
      id: 76 // A8 POS机
    },
    physicalAdvancedCard: {
      id: 79 // 高级版实体卡
    },
    physicalProfessional: {
      id: 80 // 行业版实体卡
    },
    clothesProfessional: {
      id: 121 // 服装鞋帽行业终身版
    },
    motherCareProfessional: {
      id: 122 // 母婴行业终身版
    },
    beautyProfessional: {
      id: 123 // 丽人行业终身版
    },
    petProfessional: {
      id: 124 // 宠物行业终身版
    },
    digitalProfessional: {
      id: 125 // 数码行业终身版
    },
    eyewearProfessional: {
      id: 126 // 眼镜行业终身版
    },
    groupPackage: {
      id: 128 // 组合套餐
    },
    marterial: {
      id: -1 // 收款物料
    },
    wxCardAdvanced: {
      id: 134, // 微信会员卡至尊版
      quantity: 1
    },
    miniApp: {
      id: 136 // 小程序
    },
    T1Mini: {
      id: 91 // T1MiNi
    },
    newRetail: {
      id: 137 // 新零售套餐页
    },
    msgActivity: {
      id: 144 // 388短信特惠包一年
    },
    smsActivity: {
      id: 147 // 88短信特惠包
    },
    wxCardSuite: {
      id: 148 // 微信小程序1年套餐预购
    },
    advPermanent: {
      id: 149 // 高级终身版预购
    },
    proPermanent: {
      id: 150 // 旗舰版终身版预购
    },
    wxCardSuiteOneYear: {
      id: 151 // 微信小程序1年套餐
    },
    advPermanentLifelong: {
      id: 152 // 高级终身版
    },
    proPermanentLifelong: {
      id: 153 // 旗舰版终身版
    }
  }
}



// WEBPACK FOOTER //
// ./src/model/goods/index.js